import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PieChart } from '@mui/x-charts';
import { useDrawingArea } from '@mui/x-charts/hooks';
import type { FC } from 'react';
import type { IIsPdf } from '../../models';
import { AvaniLightTheme } from '../../theme/schemes/AvaniLightTheme';

interface AvaniWastagePieChartProps extends IIsPdf {
  data: any[];
  total: number;
}

const StyledTitle = styled('text', {
  shouldForwardProp: (prop) => prop !== 'isPDF'
})<{ isPDF: boolean }>(({ theme, isPDF }) => {
  const currentTheme = isPDF ? AvaniLightTheme : theme;
  return {
    fill: currentTheme.palette.text.primary,
    textAnchor: 'middle',
    dominantBaseline: 'central',
    fontSize: 24
  };
});

const PieCenterLabel = ({ total, isPDF = false }: { total: number } & IIsPdf) => {
  const { width, height, left, top } = useDrawingArea();

  return (
    <g>
      <StyledTitle x={left + width / 2} y={top + height / 2 + 3} isPDF={isPDF}>
        {total}%
      </StyledTitle>
    </g>
  );
};

export const AvaniWastagePieChart: FC<AvaniWastagePieChartProps> = ({ data, total, isPDF = false }) => {
  const chartColors = ['#00A7A8', '#E6007E'];

  const chartData: {
    value: number;
    label: string;
  }[] = data
    ? data
    : [
        {
          value: 0,
          label: 'no data'
        }
      ];
  const chartTotal = total ? total : 0;
  const chartLeftOffset = '-47px';

  return (
    <Box
      sx={{
        padding: 0,
        width: '125px',
        overflow: 'hidden',
        margin: '0 auto'
      }}
    >
      <Box
        sx={{
          padding: 0,
          margin: 0,
          overflow: 'hidden',
          marginLeft: chartLeftOffset
        }}
      >
        <PieChart
          series={[{ data: chartData, innerRadius: 40 }]}
          height={120}
          width={310}
          margin={{
            top: 0,
            left: 0
          }}
          colors={chartColors}
          tooltip={{ trigger: 'none' }}
          sx={{
            ['.MuiPieArc-root']: { stroke: 'none' }
          }}
          slotProps={{
            legend: { hidden: true }
          }}
        >
          <PieCenterLabel total={chartTotal} isPDF={isPDF}></PieCenterLabel>
        </PieChart>
      </Box>
    </Box>
  );
};
